import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";

const AcademicBackground = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#C3E5FD"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Academic Background</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Academic Background</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Current GPA (if available)"
                            type="email"
                            name="gpa"
                            value={formData.gpa}
                            onChange={handleInputChange}
                            placeholder="Enter current gpa"
                            error={errors.gpa}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Strongest Academic Subjects"
                            type="email"
                            name="academicSubject"
                            value={formData.academicSubject}
                            onChange={handleInputChange}
                            placeholder="Enter Strongest Academic Subjects"
                            error={errors.academicSubject}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Subjects Needing Support"
                            type="email"
                            name="needingSupport"
                            value={formData.needingSupport}
                            onChange={handleInputChange}
                            placeholder="Enter Subjects Needing Support"
                            error={errors.needingSupport}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Current / Planned AP, IB, or Honors Courses:"
                            type="email"
                            name="currentAP"
                            value={formData.currentAP}
                            onChange={handleInputChange}
                            placeholder="List here"
                            error={errors.currentAP}
                            multiline
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default AcademicBackground;